import { APP } from '../config/app';
import {
  getStoreLocation,
  getServiceRadiusKm,
  isInServiceAreaForConfig,
  getActivePlatformConfig,
} from './platformConfig';

export const isInServiceArea = (lat, lng) => isInServiceAreaForConfig(lat, lng, getActivePlatformConfig());

export const serviceAreaLabel = () => APP.town;

export { getStoreLocation, getServiceRadiusKm };
